import React, { useState } from 'react'
import CommonCard from '../../../../global/card'
import useDebounce from '../../../../../utils/customHooks'
import { useGenericQuery } from '../../../../../queries/use-generic-query'
import { useLocation } from 'react-router-dom'
import SOURCES from '../../../../../utils/constants'
import { QUERY_KEYS } from '../../../../../lib/query-constants'
import EnhancedLeadsNotSentList from './enhancedLeadsNotSentList'
import CommonSkeletonLoader from '../../../../global/loading'
import CommonPagination from '../../../../global/pagination'

const EnhancedLeadsNotSent = () => {
    const [searchLeadsNotSent, setSearchLeadsNotSent] = useState("")
    const [leadsNotSentViewType, setLeadsNotSentViewType] = useState(() => {
        return localStorage.getItem("leadsNotSentViewType") || "GRID";
    });
    const [sort, setSort] = useState({ sortType: "", sortOrder: 1 });

    const debouncedSearchTerm = useDebounce(searchLeadsNotSent, 500)

    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const pageFromQuery = parseInt(searchParams.get("page") || 1, 10);
    const limitFromQuery = parseInt(
        searchParams.get("limit") || SOURCES.DEFAULT_RECORDS_LISTING,
        10
    );
    const offsetFromQuery = parseInt(searchParams.get("offset") || "0", 10);

    const [pagination, setPagination] = useState({
        offset: offsetFromQuery,
        limit: limitFromQuery,
        page: pageFromQuery,
    });


    const keyParams = {
        offset: pagination.offset,
        limit: pagination.limit,
        searchTerm: debouncedSearchTerm,
    }

    const { data, isLoading, isFetching } = useGenericQuery({
        endpoint: "leadstatistic/leads-not-sent",
        queryKey: QUERY_KEYS.leadsNotSent.lists({ ...keyParams }),
        queryParams: { ...keyParams },
        onSuccess: () => { },
        onError: () => { },
    })



    console.log("data", data)

    const dataExist = data && (Array.isArray(data) ? data?.length > 0 : data?.length > 0);
    // const leadsData = Array.isArray(data) ? data : data?.results || [];
    const leadsData = Array.isArray(data) ? data : data || [];
    const totalRecords = data?.length || 0; // The old code used totalReords property on the array/response



    return (
        <CommonCard isSearch={{
            placeholder: "Search leads not sent",
            setSearchInput: setSearchLeadsNotSent,
            value: searchLeadsNotSent,
            show: true
        }}
            isListGridView={{
                show: true,
                viewType: leadsNotSentViewType,
                setViewType: setLeadsNotSentViewType,
                viewFor: "leadsNotSentViewType"
            }}
            isLoading={{
                show: isLoading,
                loaderCmp: (
                    <CommonSkeletonLoader
                        rows={9}
                        type={leadsNotSentViewType === "GRID" ? "card" : "table"}
                        tableLength={5}
                    />
                ),
            }}
            className={(!isLoading && isFetching) && "opacity-50"}
        >
            <EnhancedLeadsNotSentList
                isLoading={isLoading}
                noLeadsSend={leadsData}
                viewDetail={() => { }} // Logic extracted to component
                sort={sort}
                setSort={setSort}
                viewType={leadsNotSentViewType}
            />

            {(dataExist && !searchLeadsNotSent) &&
                totalRecords > SOURCES.DEFAULT_RECORDS_LISTING && (
                    <CommonPagination
                        currentPage={pagination.page}
                        defaultLimit={pagination.limit}
                        totalRecords={totalRecords}
                        setCurrentPage={setPagination}
                        activePageRecords={leadsData.length}
                        paginationFor="Leads Not Sent"
                        className="mt-4"
                    />
                )}
        </CommonCard>
    )
}

export default EnhancedLeadsNotSent